export type ServiceLineScheduleConfig = {
  minutesOfBufferTime: number,
  ignoreDriveTimeShiftStart: boolean,
  ignoreDriveTimeShiftEnd: boolean,
  useAutoscheduler: boolean,
  autoschedulerGroups: number,
  scoreWeights: {
    driveWeight:number,
    proximityWeight: number,
    utilizationWeight: number,
    shiftShorteningPenaltyWeight: number,
  }
}

export const defaultServiceLineSchedulerConfig: ServiceLineScheduleConfig = {
  minutesOfBufferTime: 5,
  ignoreDriveTimeShiftStart: false,
  ignoreDriveTimeShiftEnd: false,
  useAutoscheduler: false,
  autoschedulerGroups: 1,
  scoreWeights: {
    driveWeight: 80,
    proximityWeight: 20,
    utilizationWeight: 0,
    shiftShorteningPenaltyWeight: 0,
  }
};

export type VisitTypeScheduleConfig = {
  leadTimeDays: number,
  daysBeforeLastOption: number,
  arrivalWindowOffsetMinutes:  number,
  virtualArrivalWindowOffset: number,
  allowOverflowShifts: boolean,
  arrivalWindowBlockSchedule: string,
}

// Nor visits more than a year in the future (plus a day for any rounding / timezone issues)
export const maxDaysBeforeLastOption = 366;

export const defaultVisitTypeSchedulerConfig: VisitTypeScheduleConfig = {
  leadTimeDays: 0,
  daysBeforeLastOption: 15,
  arrivalWindowOffsetMinutes:  15,
  virtualArrivalWindowOffset: 5,
  allowOverflowShifts: false,
  arrivalWindowBlockSchedule: "",
};
